// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const marshadow: PokeData = {
  "id": 802,
  "name": "marshadow",
  "height": 7,
  "weight": 222,
  "base_experience": 270,
  "types": [
    PokeType.FIGHTING,
    PokeType.GHOST
  ],
  "api_moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "jump-kick",
    "rolling-kick",
    "counter",
    "pursuit",
    "psych-up",
    "role-play",
    "endeavor",
    "shadow-punch",
    "feint",
    "close-combat",
    "assurance",
    "copycat",
    "sucker-punch",
    "force-palm",
    "drain-punch",
    "shadow-sneak",
    "laser-focus",
    "spectral-thief"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "jump-kick",
    "rolling-kick",
    "pursuit",
    "close-combat",
    "drain-punch",
    "shadow-sneak",
    "bulk-up",
    "seismic-toss",
    "coaching",
    "spectral-snatch"
  ],
  "evolution_chain": {
    "id": 423,
    "item": null,
    "species": [
      {
        "name": "marshadow",
        "order": 802,
        "types": [
          PokeType.FIGHTING,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 148,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
